import { Container, Grid, Typography } from "@mui/material";
import React, { useState } from "react";

export const PendientesPage: React.FC<{}> = () => {
    return (
        <Container sx={{ mt: 5, border: '1px solid #517ED3', borderRadius: '5px', padding: '20px', textAlign: 'center' }}>
            <Grid container spacing={2}
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
            >
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Typography>Mis Solicitudes de Proyectos</Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    Tabla
                </Grid>
            </Grid>
        </Container>
    );
}